"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3679],{

/***/ 69673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _models_enums_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20365);
/* harmony import */ var _utils_imageSerializer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9790);





const ArticleImage = (props)=>{
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        className: "".concat(props.className, "__image"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "".concat(_models_enums_routes__WEBPACK_IMPORTED_MODULE_2__/* .Routes.InsightsArticleId */ .Z.InsightsArticleId).concat(props.url),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
                ...(0,_utils_imageSerializer__WEBPACK_IMPORTED_MODULE_4__/* .imageSerializer */ .l)(props.image)
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleImage);


/***/ }),

/***/ 33679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_TopArticles; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./components/sections/Articles/ArticleLinkImage.tsx
var ArticleLinkImage = __webpack_require__(69673);
// EXTERNAL MODULE: ./models/enums/routes.ts
var routes = __webpack_require__(20365);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
// EXTERNAL MODULE: ./node_modules/emotion-rgba/dist/index.js
var dist = __webpack_require__(49484);
;// CONCATENATED MODULE: ./components/sections/TopArticles/topArticles.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}






const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "ep308fg0"
})("margin-left:8.25rem;display:none;margin-bottom:7.5rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const Fixed = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ep308fg1"
})("padding-top:8rem;top:0;position:sticky;");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "ep308fg2"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-style:normal;font-weight:normal;font-size:1rem;line-height:2rem;margin-top:0;margin-bottom:0.5rem;");
const TopArticleWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ep308fg3"
})("display:flex;object-fit:cover;width:29.375rem;margin-bottom:1.5rem;");
const TopArticleMeta = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ep308fg4"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;width:16.875rem;");
const ArticleTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((link_default()), {
    target: "ep308fg5"
})("display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-style:normal;font-weight:normal;font-size:1.125rem;line-height:2rem;margin:0;text-decoration:none;background:linear-gradient(\n    22.45deg,", theme/* THEME.colors.primary */.C.colors.primary, " 3.28%,", theme/* THEME.colors.accent */.C.colors.accent, " 102.02%\n  );background-clip:text;color:", (0,dist.rgba)(theme/* THEME.colors.core_black */.C.colors.core_black, 1), ";transition:color 200ms ease-in-out;&:hover{color:", (0,dist.rgba)(theme/* THEME.colors.core_black */.C.colors.core_black, 0), ";}");
const ArticleAuthor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "ep308fg6"
})("color:", theme/* THEME.colors.darker_grey */.C.colors.darker_grey, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-style:normal;font-weight:normal;font-size:1rem;margin-top:0.5rem;align-self:flex-start;");

;// CONCATENATED MODULE: ./components/sections/TopArticles/topArticles.tsx







const TopArticles = (param)=>{
    let { topArticles , contentPage  } = param;
    const className = classnames_default()("top-articles");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        className: className,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Fixed, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    children: prismic_reactjs.RichText.asText(contentPage.top_insights)
                }),
                topArticles.map((topArticle, index)=>{
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopArticleWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleLinkImage/* default */.Z, {
                                className: "top-article",
                                image: topArticle.article_image,
                                url: prismic_reactjs.RichText.asText(topArticle.seo_url),
                                title: prismic_reactjs.RichText.asText(topArticle.title)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopArticleMeta, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleTitle, {
                                        href: "".concat(routes/* Routes.InsightsArticleId */.Z.InsightsArticleId).concat(prismic_reactjs.RichText.asText(topArticle.seo_url)),
                                        children: prismic_reactjs.RichText.asText(topArticle.title)
                                    }),
                                    topArticle.author && prismic_reactjs.RichText.asText(topArticle.author) !== "" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleAuthor, {
                                        children: prismic_reactjs.RichText.asText(topArticle.author)
                                    }) : null
                                ]
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/TopArticles/index.ts

/* harmony default export */ var sections_TopArticles = (TopArticles);


/***/ })

}]);